import { apiClient } from "../api_client/api_client";
import { Address, ContactPoint, HumanName, Identifier } from "../fhir-client/resources";

export interface Search {
  identifier?: Identifier[];
  name?: HumanName[];
  birthDate?: string;
  race?: string;
  ethnicity?: string;
  gender?: string;
  address?: Address[];
  telecom?: ContactPoint[];
  createIfNotExist?: boolean;
}

const apiBase = 'mpi';

const mpiApi = {
  search: async (payload: Search): Promise<any> => {
    return apiClient.post<any, any>(
      `${apiBase}/search`,
      payload
    );
  },
}

export const MpiService = {
  search: async (payload: Search): Promise<any> => {
    const response = await mpiApi.search(payload);
    if (!response) return undefined;
    return response;
  },
}